import { Routes } from '@angular/router';

export const routes: Routes = [
	{
		path: '',
		loadComponent: () =>
			import('./components/page-list/page-list.component').then(
				(component) => component.PageListComponent
			)
	}
];
